module.exports = __webpack_public_path__ + "media/images/icon/close-08c93663b89f85869849b43e8d5239d3.svg";